import { render, staticRenderFns } from "./EditCommunicationComponent.vue?vue&type=template&id=2b7e6e2b"
import script from "./EditCommunicationComponent.vue?vue&type=script&lang=js"
export * from "./EditCommunicationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports